module.exports = __webpack_public_path__ + "static/media/polen-m.48abfd6c.jpg";